/**
 * Toast Progress Bar position
 */
export default {
  Top   : 'Top',
  Bottom: 'Bottom'
}
